import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import SelectUnique from '@/components/_custom/Selector/selectUnique/selectUnique.tsx'
import { SelectOptionsDeprecated } from '@/types/Select'
import styles from './otherReservationSettings.module.scss'

interface ExpirationDurationSelectProps {
    expirationDuration: string
    setExpirationDuration: (value: string) => void
    canUpdate: boolean
}

const ExpirationDurationSelect: FunctionComponent<ExpirationDurationSelectProps> = ({
    expirationDuration,
    setExpirationDuration,
    canUpdate
}) => {
    const { t } = useTranslation()

    const expirationDurations: SelectOptionsDeprecated = [
        {
            options: [
                {
                    name: t('expiration0'),
                    value: 'expiration_0'
                },
                {
                    name: t('expiration1'),
                    value: 'expiration_1'
                },
                {
                    name: t('expiration12'),
                    value: 'expiration_12'
                },
                {
                    name: t('expiration18'),
                    value: 'expiration_18'
                },
                {
                    name: t('expiration24'),
                    value: 'expiration_24'
                },
                {
                    name: t('expiration48'),
                    value: 'expiration_48'
                },
                {
                    name: t('expiration72'),
                    value: 'expiration_72'
                },
                {
                    name: t('expiration_168'),
                    value: 'expiration_168'
                }
            ]
        }
    ]

    return (
        <SelectUnique
            selectValue={expirationDuration}
            setSelectValue={setExpirationDuration}
            selectOptions={expirationDurations}
            readOnly={!canUpdate}
            className={styles.UserInput}
            formClassName={styles.UserInput}
        />
    )
}

export default ExpirationDurationSelect
